import { dataSearchSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSearchSolid = /*#__PURE__*/createIcon(dataSearchSolid)
export default IconSearchSolid
